<template>
  <d-container
    fluid
    class="main-content-container px-0 px-md-2 px-lg-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        sm="12"
        md="6"
        lg="6"
        class="text-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Grupy maszyn</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja grupy maszyn</template>
          <template v-else>Dodawanie grupy maszyn</template>
        </h3>
      </d-col>
      <d-col
        sm="12"
        md="6"
        lg="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/maszyny/grupy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <div
          v-if="!allDataLoaded && !loadMachineError"
          class="loading-spinner pb-3 pt-3 text-center">
          <span class="loading-spinner-content text-primary">
            Trwa ładowanie danych&hellip;
          </span>
        </div>
        <template v-if="!loadMachineError">
          <d-tabs
            card
            :class="{'is-loading': !allDataLoaded}">
            <!-- Dane ogólne -->
            <d-tab
              title="Dane ogólne"
              active
              class="px-3 px-md-4">
              <h4 class="mb-3 pb-3 border-bottom">
                Dane ogólne
              </h4>

              <validation-observer
                ref="machine-form"
                tag="form">
                <d-row class="w-100">
                  <d-col sm="12" md="8">
                    <div
                      class="form-group"
                      style="max-width: 600px;">
                      <label for="name">
                        Nazwa grupy:
                      </label>

                      <validation-provider
                        rules="required"
                        name="name"
                        v-slot="{ errors }">
                        <d-input
                          :state="errors.length ? 'invalid' : null"
                          v-model="data.name" />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                  </d-col>
                </d-row>
              </validation-observer>

              <div v-if="isEdit">
                <p class="mt-3 mb-2"><strong>Maszyny, należące do grupy</strong></p>
                <ul
                  v-if="data.machines.length"
                  class="machines-list">
                  <li
                    v-for="machine in data.machines"
                    :key="'machine-' + machine.id"
                    class="machines-list-item">
                    <router-link :to="'/maszyny/edycja/' + machine.id">
                      {{ machine.name }}
                    </router-link>
                  </li>
                </ul>
                <p
                  v-else
                  class="text-warning">
                  Brak maszyn przypisanych do grupy.
                </p>
              </div>

              <d-alert
                v-if="loadError"
                show
                theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                  href="javascript:window.location.reload();"
                  class="alert-link">
                  Odśwież stronę
                </a>
                aby spróbować ponownie.
              </d-alert>
            </d-tab>
          </d-tabs>
        </template>
        <template v-else>
          <d-alert
            show
            theme="warning"
            class="my-5 mx-5"
            style="font-weight: bold;">
            Wczytywanie danych nie powiodło się. Sprawdź poprawność podanego URL lub
            <a
              href="javascript:window.location.reload();"
              class="alert-link"
              style="font-weight: bold; text-decoration: underline;">
              odśwież stronę
            </a>
            aby spróbować ponownie.
          </d-alert>
        </template>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'machines-group-form',
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: 0,
        machines: [],
        name: ''
      },
      loaded: false,
      loadError: false,
      loadMachineError: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        method: 'get',
        endpointBase: '/api/machines/groups/item/',
        instanceFields: ['id', 'machines', 'name'],
        loadedKey: 'loaded',
        errorKey: 'loadMachineError'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['machine-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/api/machines/groups/update/' + this.id : '/api/machines/groups/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano grupę maszyn',
        successText: 'Wybrana grupa maszyn została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja grupy maszyn nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/maszyny/grupy');
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name
      };

      return formDataToSend;
    }
  }
};
</script>

<style lang="scss" scoped>
.machines-list {
  margin: 0;
  padding-left: 25px;

  &-item {
    margin: 10px 0;
  }
}
</style>
